import { UserPlayersModule } from '@/modules/fantasy/fixture/contest-details/user-players';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  userTeamId: z.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/contest-details/user-players'
)({
  validateSearch: searchSchema,
  component: UserPlayersPage,
});

function UserPlayersPage() {
  return <UserPlayersModule />;
}
